import { INBOX_PARTICIPATION } from '../../../constants/endpoints';
import request from './request';

export default async (conversationId, userId, readUpTo) => {
  const config = {
    url: INBOX_PARTICIPATION(conversationId, userId),
    method: 'patch',
    data: {
      participant: {
        readUpTo,
      },
    },
  };
  const response = await request(config);
  return response.data.conversation;
};
